import { Moon, Sun } from "@phosphor-icons/react";
import { useTheme } from "@/contexts/ThemeContext";

export default function ThemeToggle({ className = "", compact = false }) {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === "dark";

  return (
    <button
      type="button"
      onClick={toggleTheme}
      data-testid="theme-toggle"
      title={isDark ? "Switch to light theme" : "Switch to dark theme"}
      aria-label={isDark ? "Switch to light theme" : "Switch to dark theme"}
      className={`touch-target inline-flex items-center justify-center gap-2 border border-app-border bg-app-surface hover:bg-app-hover transition-colors ${
        compact ? "px-2.5 py-2" : "px-3 py-2.5 w-full"
      } ${className}`}
    >
      {isDark ? <Sun size={compact ? 16 : 18} weight="duotone" className="text-[#F59E0B]" /> : <Moon size={compact ? 16 : 18} weight="duotone" className="text-[#6366F1]" />}
      {!compact && (
        <span className="font-mono-d text-[10px] uppercase tracking-widest text-app-subtle">
          {isDark ? "Light mode" : "Dark mode"}
        </span>
      )}
    </button>
  );
}
